import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import WarehouseQuoteRateForm from './forms/WareHouseRatesForms/WareHouseRatesForm';
import useWarehouseQuoteRatesService from '../../../../../app/services/hooks/useWareHouseQuoteRateService';
import { defaultWarehouseQuoteRateDataForm, WarehouseQuoteRateDataForm } from '../../../../../app/models/WareHouseQuoteRates';
import { Currency } from '../../../../../app/models/Currency';
import { Depot } from '../../../../../app/models/Depot';
import { Product } from '../../../../../app/models/Product';
import { Unit } from '../../../../../app/models/Unit';
import useReactConfirmAlert from '../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../contexts/AppContext';
interface Props {
    quoteId: number;
    onSaved: () => void;
    onCancel: () => void;
    onError?: () => void;
    // depots: Depot[];
    // products: Product[];
    // currencies: Currency[];
    // units: Unit[];
}

const WarehouseQuoteRatesCreate = ({ 
    quoteId,
    onSaved,
    onCancel,
    onError,
    // depots,
    // products,
    // currencies,
    // units
 }: Props) => {
    const { createWarehouseQuoteRate,fetchingCreateWarehouseQuoteRate, storeWarehouseQuoteRate } = useWarehouseQuoteRatesService();
    
    const { hideLoading } = useContext(AppContext);
    
   const [form, setForm] = useState<WarehouseQuoteRateDataForm>({
        quote_id: quoteId,

        container_entry_fee: 0,
        daily_storage_fee: 0,
        container_exit_fee: 0,

        container_entry_fee_unit_id: 0,
        daily_storage_fee_unit_id: 0,
        container_exit_fee_unit_id: 0,

        container_entry_fee_currency_id: 0,
        daily_storage_fee_currency_id: 0,
        container_exit_fee_currency_id: 0,

        additional_comments: '',

        depot_id: 0,
        product_id: 0,
    });


    const [depots, setDepots] = useState<Depot[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);

    const [errorFields, setErrorFields] = useState<any>();



    const create = () => {
        // sólo se ejecuta una vez al montar
        createWarehouseQuoteRate(quoteId, {
        onSuccess: (response: ServiceResponse) => {
            setDepots(response.data.depots);
            setProducts(response.data.products);
            setCurrencies(response.data.currencies);
            setUnits(response.data.units);
            if (hideLoading) hideLoading();
        },
        onError: (response: ServiceResponse) => {
            if (hideLoading) hideLoading();
            toast.error(response.message);
            onError && onError();
        }
        });
    };
    useEffect(() => {
        create();
    }, []);
    const store = () => {
        storeWarehouseQuoteRate(form, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },

            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }

        });
    };
    if (fetchingCreateWarehouseQuoteRate) {
        return <p>Cargando datos de almacenamiento…</p>;
    }

    return (
        <>
            <WarehouseQuoteRateForm
                rateForm={form}
                setRateForm={setForm}
                depots={depots}
                products={products}
                currencies={currencies}
                units={units}   
                errorFields={errorFields}            // disableUpdate={false}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} />
                </div>
            </div>
        </>
    );
};

export default WarehouseQuoteRatesCreate;
